/**
 * The default skin is light.
 */
var DefaultSkin = {
    fill: "#ddd",
    border: "#333",
    disabled: "#888",
    hover: "#000",
    active: "rgb(255,215,0,0.8)",
    radius: 8
};
/**
 * The dark skin works best on dark maps.
 */
var DarkSkin = {
    fill: "#333",
    border: "#cfcfcf",
    disabled: "#888",
    hover: "#fff",
    active: "rgb(255,215,0,0.8)",
    radius: 8
};
export { DefaultSkin, DarkSkin };
